<template>
	<div>
		<v-dialog v-model="visible" width="1080" persistent>
			<v-card>
				<v-card-title>
					<v-icon style="margin-right: 10px">{{ icon }} </v-icon>
					{{ title }}
				</v-card-title>
				<v-card-text>
					<v-form ref="form" v-model="formValid">
						<v-container>
							<v-row align="start" class="item-content">
								<v-col class="item-content">
									<v-text-field v-model="item.uid" label="사용자 식별 값" type="text" filled disabled />
								</v-col>
								<v-col class="item-content">
									<v-text-field v-model="item.signUpMethodTypeName" label="가입유형" type="text" filled disabled />
								</v-col>
								<v-col class="item-content">
									<v-text-field
										label="생성일"
										type="text"
										filled
										readonly
										name="user-createAt"
										:value="!$utils.isEmpty(item.createAt) ? $moment(item.createAt.toDate()).format('YYYY/MM/DD HH:mm:ss') : ''"
									/>
								</v-col>
							</v-row>
							<v-row align="start" class="item-title">
								<v-col class="item-content">
									<v-text-field v-model="item.email" label="이메일" type="text" filled readonly />
								</v-col>
								<v-col class="item-content">
									<v-text-field v-model="item.name" label="이름" type="text" filled readonly />
								</v-col>
								<v-col class="item-content">
									<v-text-field v-model="item.nickname" label="닉네임" type="text" filled readonly />
								</v-col>
							</v-row>
							<v-row align="start" class="item-title">
								<v-col class="item-content">
									<v-text-field v-model="item.phoneNum" label="연락처" type="text" filled readonly />
								</v-col>
								<v-col class="item-content"> </v-col>
								<v-col class="item-content"> </v-col>
							</v-row>
							<v-row align="start" class="item-title">
								<v-col class="item-title">
									<v-icon style="margin-right: 10px">{{ 'mdi-image' }} </v-icon>사진
								</v-col>
							</v-row>
							<v-row align="start" class="item-content">
								<v-col align="start" class="item-content">
									<v-img v-if="$utils.isEmpty(item.imageUrl) == false" :src="item.imageUrl" width="300" contain />
									<div v-if="$utils.isEmpty(item.imageUrl) == true" height="360px">없음</div>
								</v-col>
							</v-row>
							<v-row align="start" class="item-title">
								<v-col class="item-title">
									<v-icon style="margin-right: 10px">{{ 'mdi-history' }} </v-icon>이용내역
								</v-col>
							</v-row>
							<v-row align="start">
								<v-col>
									<v-data-table
										:headers="headers"
										:items="reservations"
										style="cursor: pointer"
										@click:row="showItem"
										:items-per-page="50"
										:footerProps="{ 'items-per-page-options': [20, 50, 100, -1] }"
									>
										<template v-slot:item.reservationDay="{ item }">
											<!-- {{ $moment(item.reservationDay.toDate()).format('YYYY/MM/DD') }} -->
											{{ formatTimestamp(item.startAt, 'YYYY/MM/DD') }}
										</template>
										<template v-slot:item.startAt="{ item }">
											<!-- {{ $moment(item.startAt.toDate()).format('HH:mm') }} -->
											{{ formatTimestamp(item.startAt, 'HH:mm') }}
										</template>
										<template v-slot:item.endAt="{ item }">
											<!-- {{ $moment(item.endAt.toDate()).format('HH:mm') }} -->
											{{ formatTimestamp(item.endAt, 'HH:mm') }}
										</template>
										<template v-slot:item.price="{ item }"> {{ $utils.addComma(item.price) }}원 </template>
									</v-data-table>
								</v-col>
							</v-row>
						</v-container>
					</v-form>
				</v-card-text>
				<v-card-actions class="d-flex justify-right">
					<v-spacer></v-spacer>
					<v-btn v-if="okButton" rounded :color="$theme.primary" dark elevation="0" @click="onOk">{{ okButtonText }}</v-btn>
					<v-btn rounded :color="$theme.lightGrey" dark elevation="0" @click="$emit('onCancel')">{{ cancelButtonText }}</v-btn>
					<v-btn v-if="deleteButton" rounded :color="$theme.red" dark elevation="0" @click="$emit('onDelete')">{{ deleteButtonText }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<reservation-edit-dialog
			:show="editDialog"
			:item="selectedItem"
			icon="mdi-clipboard"
			title="예약 상세정보"
			okButtonText="확인"
			:okButton="false"
			cancelButtonText="닫기"
			:deleteButton="false"
			deleteButtonText="삭제"
			@onCancel="
				selectedItem = $models.ReservationModel.create();
				editDialog = false;
			"
			:isDesigner="false"
		>
		</reservation-edit-dialog>

		<!-- 처리중입니다 다이얼로그 -->
		<message-dialog :show="workingStateDialog" message="처리중입니다. 잠시만 기다려주세요." :okButton="false" :cancelButton="false" />
	</div>
</template>

<script>
	import { formatTimestamp } from '@/js/util';

	export default {
		name: 'UserEditDialog',
		props: {
			show: {
				default: false,
			},
			icon: {
				default: '',
			},
			title: {
				default: '',
			},
			okButton: {
				default: true,
			},
			deleteButton: {
				default: false,
			},
			okButtonText: {
				default: 'Confirm',
			},
			cancelButtonText: {
				default: 'Cancel',
			},
			deleteButtonText: {
				default: 'Delete',
			},
			item: {
				default: {},
			},
		},
		data: () => ({
			visible: false,
			reservations: [],
			formValid: false,
			workingStateDialog: false,
			headers: [
				{
					text: '예약일',
					align: 'start',
					sortable: true,
					value: 'reservationDay',
				},
				{
					text: '시작시간',
					align: 'start',
					sortable: true,
					value: 'startAt',
				},
				{
					text: '종료시간',
					align: 'start',
					sortable: true,
					value: 'endAt',
				},
				{
					text: '지점',
					align: 'start',
					sortable: true,
					value: 'storeName',
				},
				{
					text: '디자이너',
					align: 'start',
					sortable: true,
					value: 'designerName',
				},
				{
					text: '항목',
					align: 'start',
					sortable: true,
					value: 'hairTitle',
				},
				{
					text: '금액',
					align: 'start',
					sortable: true,
					value: 'price',
				},
			],
			editDialog: false,
			selectedItem: {},
		}),
		watch: {
			async show() {
				this.visible = this.show;
				this.$nextTick(() => {
					if (this.$refs.form) {
						this.$refs.form.resetValidation();
					}
				});
				if (this.$utils.isEmpty(this.item) == false) {
					this.reservations = await this.$database.loadReservationsOfUser(this.item.uid);
				}
			},
			async item() {},
		},
		mounted() {
			document.addEventListener('keydown', this.handleKeydown);
		},
		beforeDestroy() {
			document.removeEventListener('keydown', this.handleKeydown);
		},
		methods: {
			formatTimestamp,
			handleKeydown(event) {
				if (event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27) {
					this.$emit('onCancel');
				}
			},
			onOk() {
				this.$refs.form.validate();
				if (this.formValid) {
					this.$emit('onOk', this.item);
				}
			},
			showItem(item) {
				this.selectedItem = this.$models.ReservationModel.set(item);
				this.selectedItem.id = item.id;
				this.editDialog = true;
			},
		},
	};
</script>
